module.exports = __webpack_public_path__ + "img/plus-bg-btn.0832eb74.svg";